export const Variant = {
    DISPLAY: 'display',
    HEADING_1: 'heading-1',
    HEADING_2: 'heading-2',
    HEADING_3: 'heading-3',
    BODY_REGULAR: 'body-regular',
    BODY_STRONG: 'body-strong',
    BODY_EXTRA_STRONG: 'body-extra-strong',
    SUBTEXT_REGULAR: 'subtext-regular',
    SUBTEXT_STRONG: 'subtext-strong',
    LINK_1_REGULAR: 'link-1-regular',
    LINK_1_STRONG: 'link-1-strong',
    LINK_2_REGULAR: 'link-2-regular',
    LINK_2_STRONG: 'link-2-strong',
    BUTTON: 'button',
};
export const Alignment = {
    LEFT: 'left',
    CENTER: 'center',
    RIGHT: 'right',
};
export const VariantTags = {
    [Variant.DISPLAY]: 'h1',
    [Variant.HEADING_1]: 'h1',
    [Variant.HEADING_2]: 'h2',
    [Variant.HEADING_3]: 'h3',
    [Variant.BODY_REGULAR]: 'p',
    [Variant.BODY_STRONG]: 'p',
    [Variant.BODY_EXTRA_STRONG]: 'p',
    [Variant.SUBTEXT_REGULAR]: 'p',
    [Variant.SUBTEXT_STRONG]: 'p',
    [Variant.LINK_1_REGULAR]: 'span',
    [Variant.LINK_1_STRONG]: 'span',
    [Variant.LINK_2_REGULAR]: 'span',
    [Variant.LINK_2_STRONG]: 'span',
    [Variant.BUTTON]: 'span', // Only used in Button components. It is put here to reduce css boilerplate
};
